<template>
  <div class="malay-spend">
    <div class="page-section" style="border-top: none;">
      <el-form class="page-search__form" ref="searchForm" :model="listInfo">
        <div class="page-search__item page-search__item_large">
          <el-form-item>
            <el-date-picker
              v-model="listInfo.date"
              unlink-panels
              clearable
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('common.dateRangeTo')"
              :start-placeholder="$t('common.dateStart')"
              :end-placeholder="$t('common.dateEnd')"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-input :placeholder="$t('common.account')" clearable v-model="listInfo.mobile"></el-input>
          </el-form-item>
        </div>
        <div class="page-search__btns">
          <div class="page-search__btns-left">
            <el-button
              type="primary"
              class="page-button_medium page-button_blue"
              :loading="downloadLoading"
              @click="download"
            >{{ $t('common.exportReport') }}</el-button>
          </div>
          <div class="page-search__btns-right">
            <el-button type="primary" class="page-button_medium" @click="getMalayRechargeDate()">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearch">{{ $t('common.cancel') }}</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="page-section">
      <div class="page-table" v-if="tableHeight > 0">
        <el-table
          :data="listData"
          :max-height="tableHeight + 'px'"
          v-loading="listLoading"
          :element-loading-text="$t('common.loading')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="gmtCreate" :label="$t('common.time')" min-width="260px"></el-table-column>
          <el-table-column
            prop="loginAccount"
            :label="$t('common.rechargeAccount')"
            :formatter="formatToEmpty"
            min-width="250px"
          ></el-table-column>
          <el-table-column
            prop="outTradeNo"
            :label="$t('common.transactionNo')"
            :formatter="formatToEmpty"
            min-width="260px"
          ></el-table-column>
          <el-table-column prop="visaFee" :formatter="formatToYuan" :label="$t('common.rechargeAmount')" min-width="250px"></el-table-column>
        </el-table>
      </div>
      <div class="page-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getMalayRechargeDate"
          :current-page="listInfo.pageNum"
          :page-size="listInfo.pageSize"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as financialApi from '@/apis/financial'
import { formatToYuan, formatToEmpty } from '@/utils/formatters'
import { getBaseURL } from '@/utils/util'
import { defaultSearchDate } from '@/data/constant'

export default {
  name: 'malayExpenditure',
  props: {
    tableHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formatToYuan,
      formatToEmpty,
      listInfo: {
        visaFeeType: 'CHARGE_MY',
        date: defaultSearchDate,
        dateFrom: defaultSearchDate[0],
        dateTo: defaultSearchDate[1],
        mobile: '',
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      },
      listData: [],
      listLoading: false,
      downloadLoading: false,
    }
  },
  activated() {
    this.getMalayRechargeDate()
  },
  methods: {
    async getMalayRechargeDate(pageNum = 1) {
      this.listLoading = true
      try {
        this.listInfo.pageNum = pageNum

        const result = await financialApi.getAccountRechargeDate(this.listInfo)
        this.listLoading = false

        if (result) {
          const { records, pageNum, totalCount } = result.pageInfo
          this.listData = records || []
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          }
        }
      } catch (err) {
        this.listLoading = false
        throw new Error(err)
      }
    },
    resetSearch() {
      this.listInfo = {
        visaFeeType: 'CHARGE_MY',
        date: defaultSearchDate,
        dateFrom: defaultSearchDate[0],
        dateTo: defaultSearchDate[1],
        mobile: '',
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      }
      this.$refs.searchForm.clearValidate()
      this.getMalayRechargeDate()
    },
    handleDateChange(value) {
      if (value) {
        const [startDate, endDate] = value
        if (startDate && endDate) {
          this.listInfo.dateFrom = startDate
          this.listInfo.dateTo = endDate
        }
      } else {
        this.listInfo.dateFrom = ''
        this.listInfo.dateTo = ''
      }
    },
    async download() {
      this.downloadLoading = true
      try {
        const result = await financialApi.downloadAccountRechargeData(
          this.listInfo
        )
        this.downloadLoading = false
        if (result) {
          window.open(getBaseURL('api', true) + result.pageInfo.downloadUrl)
        }
      } catch (err) {
        this.downloadLoading = false
        throw new Error(err)
      }
    },
  },
}
</script>
